// extracted by mini-css-extract-plugin
export default {"welcomeWrapper":"Welcome_welcomeWrapper__FpvxY","description":"Welcome_description__Upick","fadeIn":"Welcome_fadeIn__P7Xov","fadeOut":"Welcome_fadeOut__6JHvI"};